import React from 'react';

import classNames from 'classnames';

import Footer from '@/common/components/shared/footer/footer.component';
import Header from '@/common/components/shared/header/header.component';

interface Props {
  children: React.ReactNode;
  hasHeader?: boolean;
  hasFooter?: boolean;
  stickyHeader?: boolean;
  parentClassName?: string;
  bodyClassname?: string;
}

const Layout = ({
  children,
  parentClassName,
  bodyClassname,
  stickyHeader = true,
  hasHeader = false,
  hasFooter = false,
}: Props) => {
  return (
    <div
      className={classNames(
        'mx-auto min-h-screen flex flex-col  bg-silver-60',
        parentClassName
      )}
    >
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:right-2 focus:z-999999 focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-black-default focus:shadow-section"
      >
        رفتن به محتوای اصلی
      </a>
      <div className="flex-1 flex flex-col">
        {hasHeader && <Header sticky={stickyHeader} />}
        <main
          id="main-content"
          className={classNames(
            'px-0 sm:px-2.5 md:px-10 lg:px-20 xl:px-30 pb-6 pt-0 lg:pb-26.25 lg:pt-6 flex-1 flex flex-col gap-22.5 sm:gap-36 overflow-visible',
            bodyClassname
          )}
        >
          {children}
        </main>
        {hasFooter && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
